import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-brand-navy text-white py-16 md:py-24 px-4 border-b-4 border-brand-gold" data-id="element-30">
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-31">
        <div className="space-y-8 text-center lg:text-left" data-id="element-32">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black leading-tight text-white" data-id="element-33">
            CÓMO REPARAR TU CRÉDITO EN 90 DÍAS{' '}
            <span className="text-brand-gold" data-id="element-34">
              (Y CONSEGUIR LAS LLAVES DE TU CASA PROPIA)
            </span>{' '}
            SIN PAGAR MILES A ABOGADOS
          </h1>
          <h2 className="font-body text-xl md:text-2xl text-gray-300 font-medium leading-relaxed" data-id="element-35">
            El método exacto para que una mujer latina elimine deudas injustas,
            suba su puntaje FICO y sea aprobada por el banco, incluso si ya te
            dijeron que "no".
          </h2>
          <div className="pt-4" data-id="element-36">
            <CTAButton data-id="element-37">¡QUIERO SER LA JEFA DE MI CRÉDITO AHORA!</CTAButton>
            <p className="mt-4 text-sm text-gray-400 font-body" data-id="element-38">
              Acceso instantáneo después del pago.
            </p>
          </div>
        </div>
        <div className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-39">
          <div className="absolute inset-0 bg-brand-gold blur-3xl opacity-20 rounded-full" data-id="element-40"></div>
          <img src="https://cdn.magicpatterns.com/uploads/f8DBBKsKHTopHRhB4n8BGq/heylloyd-image-1772071808043.png" alt="La Jefa de su Crédito - Manual en Tablet" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-41" />
        </div>
      </div>
    </section>;
}